/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_UnitInputs */

const vi_product_unit = /** @type {(inputs: Product_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn vị tính`)
};

/**

* @param {Product_UnitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_unit = /** @type {((inputs?: Product_UnitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_UnitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_unit(inputs)
});